import { render, staticRenderFns } from "./modal.component.vue?vue&type=template&id=640f0bbf&scoped=true"
import script from "./modal.component.vue?vue&type=script&lang=js"
export * from "./modal.component.vue?vue&type=script&lang=js"
import style0 from "./modal.component.vue?vue&type=style&index=0&id=640f0bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f0bbf",
  null
  
)

export default component.exports